import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const ManageAgencies = () => {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAgencies();
  }, []);

  const fetchAgencies = async () => {
    try {
      setLoading(true);
      
      const data = await apiService.get('/agencies');
      setAgencies(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching agencies:', err);
      setError('Failed to load agencies. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleAgencyClick = (agencyId) => {
    navigate(`/agencies/${agencyId}`);
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Agencies</h1>
        </div>
        <div className="loading-state">
          <p>Loading agencies...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Agencies</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button type="button" onClick={fetchAgencies} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Manage Agencies</h1>
      </div>

      <div className="properties-table agencies-table">
        <div
          className="description-grid-shell description-grid-shell--agents"
          role="table"
          aria-label="Agencies"
        >
          <div role="row" className="description-grid-row description-grid-head">
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              ID
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Agency Name
            </div>
            <div
              role="columnheader"
              className="description-grid-cell description-grid-cell-head description-grid-cell-description"
            >
              Description
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Contact Person
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Contact Number
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Email
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Status
            </div>
          </div>

          {agencies.map((agency) => (
            <div role="row" className="description-grid-row" key={agency.id}>
              <div role="cell" className="description-grid-cell description-grid-cell-id">
                <strong>{agency.id}</strong>
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-tight">
                <a 
                  href="#"
                  className="property-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleAgencyClick(agency.id);
                  }}
                  title="Click to edit agency details"
                >
                  {agency.agencyName}
                </a>
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-description">
                {agency.description}
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-tight">
                {agency.contactPerson}
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-tight">
                {agency.contactNumber}
              </div>
              <div
                role="cell"
                className="description-grid-cell description-grid-cell-email"
                title={agency.emailAddress || ''}
              >
                {agency.emailAddress}
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-status">
                <span className={`status-badge ${agency.isActive ? 'active' : 'inactive'}`}>
                  {agency.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ManageAgencies;
